import * as t from 'io-ts'
// import { fsmStateToNull } from 'gws-ui-io/task-io'

// import { taskTypeList, scrapeStrategies } from '.'
import { TaskSortFilterIO } from '../queries/tasks/tasks-query'
// const maintenanceTypeStrings = ['JOB_REJECTION', 'JOB_FAILURE', 'Other']
// const scrapeStrategyStrings = scrapeStrategies
// const taskTypeStrings = taskTypeList
// const taskStates = Object.keys(fsmStateToNull)

export const taskDefaultValues: Record<string, boolean> = {
  Yes: true,
  No: false,
}

export const ActiveFiltersDecodedIO = t.union([
  t.undefined,
  t.partial({
    assignees: t.array(t.string),
    states: t.array(t.string),
    tags: t.array(t.string),
    maintenanceTypes: t.array(t.string),
    fsmIds: t.array(t.string),
    uuids: t.array(t.string),
    muids: t.array(t.string),
    scrapeStrategies: t.array(t.string),
    workstreamIds: t.array(t.string),
    taskIds: t.array(t.string),
    backlogIds: t.array(t.string),
    text: t.string,
    taskTypes: t.array(t.string),
    priority: t.string,
    sorting: TaskSortFilterIO,
    fastlane: t.string,
    isAuthorized: t.string,
    dueTimestamp: t.number,
  }),
])

export type ActiveFilterT = t.TypeOf<typeof ActiveFiltersDecodedIO>

export const SEARCH_DELIMITER = ' : '
export const SPLIT_DELIMITER = ', '
const VALID_SEARCH_TAG_EXP = /^\w+\s?\w+\s:\s\w+/
const UUID_EXP = /\w{8}(-\w{4}){3}-\w{12}/

const mapLabelToKeyword = {
  WorkstreamID: 'workstreamIds',
  Tag: 'tags',
  Priority: 'priority',
  Type: 'taskTypes',
  Text: 'text',
  TaskID: 'taskIds',
  BacklogID: 'backlogIds',
  MaintenanceType: 'maintenanceTypes',
  FsmID: 'fsmIds',
  ConfigurationID: 'uuids',
  ScrapeStrategy: 'scrapeStrategies',
  MUID: 'muids',
  State: 'states',
  Assignee: 'assignees',
  Fastlane: 'fastlane',
  Authorized: 'isAuthorized',
} as const

export type searchLabelT = keyof typeof mapLabelToKeyword
export type SearchkeywordTypeT = typeof mapLabelToKeyword[searchLabelT]

export const SEARCH_OPTIONS_BY_VIEW = {
  workstreamIds: true,
  taskTypes: true,
  maintenanceTypes: true,
  fsmIds: true,
  uuids: true,
  muids: true,
  scrapeStrategies: true,
  tags: true,
  priority: true,
  states: true,
  assignees: true,
  text: true,
  fastlane: true,
  isAuthorized: true,
  taskIds: true,
  backlogIds: true,
}

export type ViewSearchOptions = typeof SEARCH_OPTIONS_BY_VIEW
// export type ValidSearchOptions = Exclude<ViewSearchOptions, undefined>

// /** Search Provider contains metadata for each search key.\
//  * name: Name of the search key\
//  * value: Current value for that key\
//  * isArray: Tells us if the search key can take multiple values.\
//  * label: Label to be shown in the searchbox for this key.\
//  * matchExp: REGEXP to match with the value.\
//  * matchStrings: Array of static strings to match with input value.\
//  * defaultSuggest: If set to true, this option will always appear in suggestion list.\
//  */
// export type SearchProviderT = {
//   name: SearchkeywordTypeT
//   value: string | null
//   isArray?: boolean
//   label: searchLabelT
//   matchExp?: RegExp
//   matchStrings?: string[]
//   defaultSuggest?: boolean
//   defaultValues?: string[]
// }

// export type SearchProviderTemplateT = Record<string, SearchProviderT>

// export const providerTemplate: SearchProviderTemplateT = {
//   workstreamIds: {
//     name: 'workstreamIds',
//     value: null,
//     isArray: true,
//     label: 'WorkstreamID',
//     matchExp: UUID_EXP,
//   },
//   fsmIds: {
//     name: 'fsmIds',
//     value: null,
//     isArray: true,
//     label: 'FsmID',
//     matchExp: UUID_EXP,
//   },
//   uuids: {
//     name: 'uuids',
//     value: null,
//     isArray: true,
//     label: 'ConfigurationID',
//     matchExp: UUID_EXP,
//   },
//   taskTypes: {
//     name: 'taskTypes',
//     value: null,
//     isArray: true,
//     label: 'Type',
//     matchStrings: taskTypeStrings,
//   },
//   maintenanceTypes: {
//     name: 'maintenanceTypes',
//     value: null,
//     isArray: true,
//     label: 'MaintenanceType',
//     matchStrings: maintenanceTypeStrings,
//   },
//   scrapeStrategies: {
//     name: 'scrapeStrategies',
//     value: null,
//     isArray: true,
//     label: 'ScrapeStrategy',
//     matchStrings: scrapeStrategyStrings,
//   },
//   muids: {
//     name: 'muids',
//     value: null,
//     isArray: true,
//     label: 'MUID',
//     matchExp: /^\d{16,20}$/,
//   },
//   states: {
//     name: 'states',
//     value: null,
//     isArray: true,
//     label: 'State',
//     matchStrings: taskStates,
//   },
//   assignees: {
//     name: 'assignees',
//     value: null,
//     isArray: true,
//     label: 'Assignee',
//   },
//   priority: {
//     name: 'priority',
//     value: null,
//     label: 'Priority',
//     matchExp: /^\d{1,5}$/,
//   },
//   text: { name: 'text', value: null, label: 'Text', defaultSuggest: true },
//   tags: {
//     name: 'tags',
//     value: null,
//     isArray: true,
//     label: 'Tag',
//     defaultSuggest: true,
//   },
//   fastlane: {
//     name: 'fastlane',
//     value: null,
//     label: 'Fastlane',
//     defaultSuggest: false,
//     defaultValues: Object.keys(taskDefaultValues),
//   },
//   isAuthorized: {
//     name: 'isAuthorized',
//     value: null,
//     label: 'Authorized',
//     defaultSuggest: false,
//     defaultValues: Object.keys(taskDefaultValues),
//   },
//   taskIds: {
//     name: 'taskIds',
//     value: null,
//     isArray: true,
//     label: 'TaskID',
//     matchExp: /\w{18}:\w{18}(,\w{18}:\w{18})*/,
//   },
//   backlogIds: {
//     name: 'backlogIds',
//     value: null,
//     isArray: true,
//     label: 'BacklogID',
//     matchExp: /\d{18,18}/,
//   },
// } as const

// /** Function to generate a list of search providers using searchoptions available for this view.\
//  *  It is initialised with default values. */
// export const getDefaultProviderList = (
//   viewSearchOptions: ValidSearchOptions,
// ): SearchProviderT[] =>
//   Object.entries(viewSearchOptions)
//     .filter(([, value]) => value)
//     .map(([option]) => providerTemplate[option])

// /** Function to validate any input by user in the searchbox, and return list of suggestions.  */
// export const validatedSearchInput = (
//   inpValue: string,
//   providerList: SearchProviderT[],
//   allUserList?: string[],
// ) => {
//   const reg = new RegExp(inpValue, 'i')
//   var searchSuggestions: string[] = []
//   if (inpValue.match(VALID_SEARCH_TAG_EXP)) {
//     const [keywordKey, keywordVal] = inpValue.split(SEARCH_DELIMITER)
//     const searchkey = mapLabelToKeyword[keywordKey as searchLabelT]

//     const { matchExp, matchStrings, label, defaultSuggest } =
//       providerTemplate[searchkey]
//     if (matchExp && keywordVal.match(matchExp)) {
//       searchSuggestions.push(inpValue)
//     }
//     if (matchStrings) {
//       matchStrings?.forEach((itemObj) => {
//         if (
//           itemObj.match(new RegExp(keywordVal, 'i')) &&
//           searchSuggestions.length < 5
//         ) {
//           searchSuggestions.push(label + SEARCH_DELIMITER + itemObj)
//         }
//       })
//     }

//     if (defaultSuggest) {
//       searchSuggestions.push(label + SEARCH_DELIMITER + keywordVal)
//     }
//     if (!!allUserList) {
//       const matchedUsers = allUserList.filter((user) =>
//         user.match(new RegExp(`^${keywordVal}`, 'i')),
//       )

//       searchSuggestions = searchSuggestions.concat(
//         matchedUsers.map(
//           (matchedUser) =>
//             providerTemplate.assignees.label + SEARCH_DELIMITER + matchedUser,
//         ),
//       )
//     }
//   } else {
//     providerList.forEach(({ label, matchExp, matchStrings, defaultValues }) => {
//       if (label.match(new RegExp(`^${inpValue}`, 'i'))) {
//         if (!defaultValues?.length) {
//           searchSuggestions.push(label + SEARCH_DELIMITER)
//         } else {
//           defaultValues?.forEach((itemObj) => {
//             searchSuggestions.push(label + SEARCH_DELIMITER + itemObj)
//           })
//         }
//       }
//       const matchingInput = matchExp ? inpValue.match(matchExp)?.[0] : undefined
//       if (matchingInput) {
//         searchSuggestions.push(label + SEARCH_DELIMITER + matchingInput)
//       }
//       matchStrings?.forEach((itemObj) => {
//         if (itemObj.match(reg) && searchSuggestions.length < 5) {
//           searchSuggestions.push(label + SEARCH_DELIMITER + itemObj)
//         }
//       })
//     })
//     if (!inpValue.match(/:/)) {
//       providerList.forEach(({ defaultSuggest, label }) => {
//         if (defaultSuggest) {
//           searchSuggestions.push(label + SEARCH_DELIMITER + inpValue)
//         }
//       })
//     }
//     if (
//       !!allUserList &&
//       providerList.findIndex((item) => item.name === 'assignees') !== -1
//     ) {
//       const matchedUser = allUserList.find((user) =>
//         user.match(new RegExp(`^${inpValue}`, 'i')),
//       )
//       matchedUser &&
//         searchSuggestions.push(
//           providerTemplate.assignees.label + SEARCH_DELIMITER + matchedUser,
//         )
//     }
//   }
//   return searchSuggestions
// }

// export const getFiltersFromTag = (
//   suggestionTag: string,
//   appliedFilters: ActiveFilterT,
// ) => {
//   if (suggestionTag.match(VALID_SEARCH_TAG_EXP)) {
//     const [keywordKey, keywordVal] = suggestionTag.split(SEARCH_DELIMITER)
//     const searchkey = mapLabelToKeyword[keywordKey as searchLabelT]

//     if (searchkey) {
//       const { isArray, matchExp, matchStrings } = providerTemplate[searchkey]
//       if (matchExp && !keywordVal.match(matchExp)) {
//         return
//       } else if (matchStrings && !matchStrings.includes(keywordVal)) {
//         return
//       }
//       if (isArray) {
//         const currVal = (appliedFilters?.[searchkey] as string[]) ?? []
//         if (!currVal.includes(keywordVal)) {
//           return { [searchkey]: [...currVal, keywordVal] }
//         }
//         return { [searchkey]: currVal }
//       }
//       return { [searchkey]: keywordVal }
//     }
//   }
//   return
// }

// export const generateProviderTemplate = (
//   keywords: SearchProviderT[],
// ): SearchProviderTemplateT =>
//   keywords.reduce(
//     (obj, ele) => Object.assign(obj, { [ele.name]: { ...ele } }),
//     {},
//   )
